
import React from "react";
import { Lightbulb } from "lucide-react";
import { Button } from "../ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../ui/popover";
import { PuzzleDataContext } from "../../providers/PuzzleDataProvider";

function HintsButton() {
  const { gameData } = React.useContext(PuzzleDataContext);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" className="h-10 w-10">
          <Lightbulb className="h-5 w-5" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-80">
        <div className="grid gap-4">
          <div className="space-y-2">
            <h4 className="font-medium leading-none">Hints</h4>
            <p className="text-sm pl-4 pt-2">
              Hint: {gameData[0]?.hint || "Find related words"}
            </p>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  );
}

export default HintsButton;
